import AvailablePoints from './AvailablePoints';

export default AvailablePoints;
